import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Chip,
  LinearProgress,
  Skeleton
} from '@mui/material';
import {
  CustomTableContainer,
  CustomTable,
  CustomTableHead,
  CustomTableRow,
  CustomTableCell,
  CustomTableBody
} from '../../common';

const ActiveCourses = ({ teachers = [], loading = false }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        border: '1.5px solid #e2e8f0',
        borderRadius: '24px',
        height: '420px',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 2px 8px rgba(0,0,0,0.03)'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, fontSize: '16px', color: '#1e293b', fontFamily: 'Poppins' }}>
          My Teachers
        </Typography>
        <Chip
          label={`${teachers.length} Teachers Active`}
          size="small"
          sx={{
            bgcolor: '#FFFDF9',
            border: '1.5px solid #FFE3C3',
            color: '#FF8A00',
            fontWeight: 600,
            fontSize: '11px',
            fontFamily: 'Poppins',
            borderRadius: '6px',
            height: '24px'
          }}
        />
      </Box>
      <Typography sx={{ color: '#94a3b8', fontSize: '11px', fontFamily: 'Poppins', mb: 2 }}>
        Teachers from your enrolled classes
      </Typography>

      <CustomTableContainer
        sx={{
          border: 'none',
          flexGrow: 1,
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: '#cbd5e1 transparent',
          '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px'
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#cbd5e1',
            borderRadius: '10px',
            '&:hover': {
              backgroundColor: '#94a3b8'
            }
          }
        }}
      >
        <CustomTable size="small" stickyHeader>
          <CustomTableHead>
            <CustomTableRow>
              <CustomTableCell sx={{ color: '#94a3b8', fontWeight: 600, fontSize: '11.5px', borderBottom: '1px solid #f1f5f9', py: 1.5, pl: 0, bgcolor: '#ffffff' }}>Teacher</CustomTableCell>
              <CustomTableCell sx={{ color: '#94a3b8', fontWeight: 600, fontSize: '11.5px', borderBottom: '1px solid #f1f5f9', py: 1.5, bgcolor: '#ffffff' }}>Subjects</CustomTableCell>
              <CustomTableCell sx={{ color: '#94a3b8', fontWeight: 600, fontSize: '11.5px', borderBottom: '1px solid #f1f5f9', py: 1.5, bgcolor: '#ffffff' }}>Exam Pass Rate</CustomTableCell>
            </CustomTableRow>
          </CustomTableHead>
          <CustomTableBody>
            {loading ? (
              [1, 2, 3, 4].map((i) => (
                <CustomTableRow key={i}>
                  <CustomTableCell sx={{ py: 1.5, pl: 0 }}><Skeleton width="80%" /></CustomTableCell>
                  <CustomTableCell><Skeleton width="60%" /></CustomTableCell>
                  <CustomTableCell><Skeleton width="70%" /></CustomTableCell>
                </CustomTableRow>
              ))
            ) : teachers.length === 0 ? (
              <CustomTableRow>
                <CustomTableCell colSpan={3} sx={{ textAlign: 'center', py: 4, color: '#94a3b8', fontFamily: 'Poppins', fontSize: '13px' }}>
                  No teachers found
                </CustomTableCell>
              </CustomTableRow>
            ) : (
              teachers.map((teacher, idx) => {
                const passRate = teacher.scheduledExamPassRate || 0;
                return (
                  <CustomTableRow
                    key={idx}
                    sx={{
                      '&:hover': { bgcolor: '#f8fafc' },
                      transition: 'background-color 0.15s ease'
                    }}
                  >
                    <CustomTableCell sx={{ borderBottom: '1px solid #eaeef3', py: 1.2, pl: 0 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '12px', color: '#1e293b', fontFamily: 'Poppins', lineHeight: 1.2 }}>
                        {teacher.teacherName}
                      </Typography>
                      <Typography sx={{ color: '#94a3b8', fontSize: '10px', fontFamily: 'Poppins', mt: 0.25, lineHeight: 1 }}>
                        {teacher.passedExams}/{teacher.totalExams} exams passed
                      </Typography>
                    </CustomTableCell>
                    <CustomTableCell sx={{ borderBottom: '1px solid #eaeef3', py: 1.2, color: '#64748b', fontSize: '12px', fontFamily: 'Poppins' }}>
                      {(() => {
                        const subjects = teacher.subjects || [];
                        if (subjects.length === 0) return 'N/A';
                        if (subjects.length <= 3) return subjects.join(', ');
                        return `${subjects.slice(0, 3).join(', ')}, + ${subjects.length - 3} more`;
                      })()}
                    </CustomTableCell>
                    <CustomTableCell sx={{ borderBottom: '1px solid #eaeef3', py: 1.2, width: '130px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ flex: 1 }}>
                          <LinearProgress
                            variant="determinate"
                            value={passRate}
                            sx={{
                              height: '6px',
                              borderRadius: '3px',
                              bgcolor: '#f1f5f9',
                              '& .MuiLinearProgress-bar': {
                                bgcolor: passRate > 80 ? '#2ecc71' : passRate > 60 ? '#3b82f6' : '#FF502D',
                                borderRadius: '3px'
                              }
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontWeight: 700, fontSize: '11px', color: '#1e293b', fontFamily: 'Poppins', width: '28px', textAlign: 'right' }}>
                          {passRate}%
                        </Typography>
                      </Box>
                    </CustomTableCell>
                  </CustomTableRow>
                );
              })
            )}
          </CustomTableBody>
        </CustomTable>
      </CustomTableContainer>
    </Paper>
  );
};

export default ActiveCourses;
